import React from 'react';
import {
  Box,
  Typography,
  Grid,
  Card,
  CardContent,
  Avatar,
  Paper,
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
  Chip,
  LinearProgress,
  Button,
} from '@mui/material';
import {
  Assignment,
  CleaningServices,
  CheckCircle,
  AccessTime,
  TrendingUp,
  CalendarToday,
} from '@mui/icons-material';

const myTasks = [
  { id: 1, room: '204', type: 'Cleaning', priority: 'High', status: 'In Progress', time: '09:00 AM' },
  { id: 2, room: '305', type: 'Inspection', priority: 'Normal', status: 'Pending', time: '10:30 AM' },
  { id: 3, room: '102', type: 'Cleaning', priority: 'Normal', status: 'Pending', time: '11:00 AM' },
];

const mySchedule = [
  { day: 'Today', shift: 'Morning', time: '8:00 AM - 4:00 PM', status: 'Active' },
  { day: 'Tomorrow', shift: 'Morning', time: '8:00 AM - 4:00 PM', status: 'Scheduled' },
];

export default function StaffDashboard({ userRole, userName }) {
  const stats = [
    { label: 'Tasks Today', value: '8', icon: Assignment, color: '#1976d2' },
    { label: 'Completed', value: '5', icon: CheckCircle, color: '#2e7d32' },
    { label: 'In Progress', value: '1', icon: AccessTime, color: '#ed6c02' },
    { label: 'Pending', value: '2', icon: CleaningServices, color: '#9c27b0' },
  ];

  return (
    <Box sx={{ p: { xs: 2, sm: 3 } }}>
      <Box mb={3}>
        <Typography variant="h4" fontWeight="bold" gutterBottom>
          Welcome, {userName}!
        </Typography>
        <Typography variant="body2" color="text.secondary">
          Staff Dashboard - {userRole} Portal
        </Typography>
      </Box>

      <Grid container spacing={3} mb={3}>
        {stats.map((stat) => {
          const IconComponent = stat.icon;
          return (
            <Grid item xs={6} md={3} key={stat.label}>
              <Card sx={{ bgcolor: `${stat.color}10`, borderLeft: `4px solid ${stat.color}` }}>
                <CardContent>
                  <Box display="flex" justifyContent="space-between" alignItems="center">
                    <Box>
                      <Typography variant="body2" color="text.secondary">
                        {stat.label}
                      </Typography>
                      <Typography variant="h4" fontWeight="bold" color={stat.color}>
                        {stat.value}
                      </Typography>
                    </Box>
                    <Avatar sx={{ bgcolor: stat.color, width: 48, height: 48 }}>
                      <IconComponent />
                    </Avatar>
                  </Box>
                </CardContent>
              </Card>
            </Grid>
          );
        })}
      </Grid>

      <Grid container spacing={3}>
        <Grid item xs={12} lg={8}>
          <Paper sx={{ p: 3 }}>
            <Typography variant="h6" fontWeight="bold" gutterBottom>
              My Tasks Today
            </Typography>
            <TableContainer>
              <Table>
                <TableHead sx={{ bgcolor: '#f5f5f5' }}>
                  <TableRow>
                    <TableCell><strong>Room</strong></TableCell>
                    <TableCell><strong>Task Type</strong></TableCell>
                    <TableCell><strong>Priority</strong></TableCell>
                    <TableCell><strong>Time</strong></TableCell>
                    <TableCell><strong>Status</strong></TableCell>
                  </TableRow>
                </TableHead>
                <TableBody>
                  {myTasks.map((task) => (
                    <TableRow key={task.id} hover>
                      <TableCell><strong>{task.room}</strong></TableCell>
                      <TableCell>{task.type}</TableCell>
                      <TableCell>
                        <Chip
                          label={task.priority}
                          size="small"
                          color={task.priority === 'High' ? 'warning' : 'info'}
                        />
                      </TableCell>
                      <TableCell>{task.time}</TableCell>
                      <TableCell>
                        <Chip
                          label={task.status}
                          size="small"
                          color={task.status === 'In Progress' ? 'primary' : 'default'}
                        />
                      </TableCell>
                    </TableRow>
                  ))}
                </TableBody>
              </Table>
            </TableContainer>
          </Paper>
        </Grid>

        <Grid item xs={12} lg={4}>
          <Paper sx={{ p: 3, mb: 3 }}>
            <Typography variant="h6" fontWeight="bold" gutterBottom>
              My Schedule
            </Typography>
            {mySchedule.map((schedule, index) => (
              <Box key={index} mb={2}>
                <Box display="flex" justifyContent="space-between" alignItems="center" mb={1}>
                  <Typography variant="body2" fontWeight="bold">
                    {schedule.day}
                  </Typography>
                  <Chip
                    label={schedule.status}
                    size="small"
                    color={schedule.status === 'Active' ? 'success' : 'default'}
                  />
                </Box>
                <Typography variant="caption" color="text.secondary" display="block">
                  {schedule.shift} Shift
                </Typography>
                <Typography variant="caption" color="text.secondary">
                  {schedule.time}
                </Typography>
              </Box>
            ))}
          </Paper>

          <Paper sx={{ p: 3 }}>
            <Typography variant="h6" fontWeight="bold" gutterBottom>
              Performance
            </Typography>
            <Box mb={2}>
              <Box display="flex" justifyContent="space-between" mb={1}>
                <Typography variant="body2">Tasks Completed</Typography>
                <Typography variant="body2" fontWeight="bold">
                  62%
                </Typography>
              </Box>
              <LinearProgress variant="determinate" value={62} sx={{ height: 8, borderRadius: 4 }} />
            </Box>
            <Box>
              <Box display="flex" justifyContent="space-between" mb={1}>
                <Typography variant="body2">This Week</Typography>
                <Typography variant="body2" fontWeight="bold">
                  35/40 Tasks
                </Typography>
              </Box>
              <LinearProgress
                variant="determinate"
                value={87.5}
                color="success"
                sx={{ height: 8, borderRadius: 4 }}
              />
            </Box>
          </Paper>
        </Grid>
      </Grid>
    </Box>
  );
}
